/** @jsxImportSource @emotion/react */
import { Route, Routes } from 'react-router-dom';
import { AppUserDetails, AppUserList } from './components';
import { SelectedAppUserProvider } from './context';

export const AppUsers = () => {
  return (
    <SelectedAppUserProvider>
      <Routes>
        <Route path="/" element={<AppUserList />} />
        <Route path="/:userId" element={<AppUserDetails />} />
      </Routes>
    </SelectedAppUserProvider>
  );
};
